const CREATE_USER = 'CREATE_USER'
const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS'
const GET_ALL_USERS = 'GET_ALL_USERS'
const SET_ALL_USERS = 'SET_ALL_USERS'
const GET_USER_BY_ID = 'GET_USER_BY_ID'
const SET_USER_BY_ID = 'SET_USER_BY_ID'
const GET_MODULES_LIST = 'GET_MODULES_LIST'
const SET_MODULES_LIST = 'SET_MODULES_LIST'
const GET_USER_MODULES = 'GET_USER_MODULES'
const SET_USER_MODULES = 'SET_USER_MODULES'
const DOWNLOAD_PREVIOUS_YEAR_RESULTS = "DOWNLOAD_PREVIOUS_YEAR_RESULTS"
const SET_DOWNLOAD_PREVIOUS_YEAR_RESULTS_DATA = "SET_DOWNLOAD_PREVIOUS_YEAR_RESULTS_DATA"

const EXPORT_USERS_ASSESSMENTS = 'EXPORT_USERS_ASSESSMENTS'
const SET_USERS_ASSESSMENTS_EXCEL_DATA = 'SET_USERS_ASSESSMENTS_EXCEL_DATA'

const GET_USER_ATTEMPTS_BY_ID = 'GET_USER_ATTEMPTS_BY_ID'
const SET_USER_ATTEMPTS_BY_ID = 'SET_USER_ATTEMPTS_BY_ID'

const GET_USERS_COST_CENTERS_FILTER_LIST = 'GET_USERS_COST_CENTERS_FILTER_LIST'
const SET_USERS_COST_CENTERS_FILTER_LIST = 'SET_USERS_COST_CENTERS_FILTER_LIST'
const GET_USERS_HOME_COST_CENTERS_FILTER_LIST = 'GET_USERS_HOME_COST_CENTERS_FILTER_LIST'
const SET_USERS_HOME_COST_CENTERS_FILTER_LIST = 'SET_USERS_HOME_COST_CENTERS_FILTER_LIST'
const GET_USERS_LATEST_SCORE_FILTER_LIST = 'GET_USERS_LATEST_SCORE_FILTER_LIST'
const SET_USERS_LATEST_SCORE_FILTER_LIST = 'SET_USERS_LATEST_SCORE_FILTER_LIST'

const GET_USERS_BY_COST_CENTER = 'GET_USERS_BY_COST_CENTER'
const SET_USERS_BY_COST_CENTER = 'SET_USERS_BY_COST_CENTER'
const GET_SAVE_USER_BY_COST_CENTER = 'GET_SAVE_USER_BY_COST_CENTER'
const SET_SAVE_USER_BY_COST_CENTER = 'SET_SAVE_USER_BY_COST_CENTER'

const GET_USER_COST_CENTERS = "GET_USER_COST_CENTERS"
const SET_USER_COST_CENTERS = "SET_USER_COST_CENTERS"

const GET_USER_COST_CENTERS_MODULES_LIST = 'GET_USER_COST_CENTERS_MODULES_LIST'
const SET_USER_COST_CENTERS_MODULES_LIST = 'SET_USER_COST_CENTERS_MODULES_LIST'

const GET_SAVE_USER_COST_CENTERS_MODULES = 'GET_SAVE_USER_COST_CENTERS_MODULES'
const SET_SAVE_USER_COST_CENTERS_MODULES = 'SET_SAVE_USER_COST_CENTERS_MODULES'

export {
    CREATE_USER,
    CREATE_USER_SUCCESS,
    GET_ALL_USERS,
    SET_ALL_USERS,
    GET_USER_BY_ID,
    SET_USER_BY_ID,
    GET_MODULES_LIST,
    SET_MODULES_LIST,
    GET_USER_MODULES,
    SET_USER_MODULES,
    DOWNLOAD_PREVIOUS_YEAR_RESULTS,
    SET_DOWNLOAD_PREVIOUS_YEAR_RESULTS_DATA,
    EXPORT_USERS_ASSESSMENTS,
    SET_USERS_ASSESSMENTS_EXCEL_DATA,
    GET_USER_ATTEMPTS_BY_ID,
    SET_USER_ATTEMPTS_BY_ID,
    GET_USERS_COST_CENTERS_FILTER_LIST,
    SET_USERS_COST_CENTERS_FILTER_LIST,
    GET_USERS_HOME_COST_CENTERS_FILTER_LIST,
    SET_USERS_HOME_COST_CENTERS_FILTER_LIST,
    GET_USERS_LATEST_SCORE_FILTER_LIST,
    SET_USERS_LATEST_SCORE_FILTER_LIST,
    GET_USERS_BY_COST_CENTER,
    SET_USERS_BY_COST_CENTER,
    GET_SAVE_USER_BY_COST_CENTER,
    SET_SAVE_USER_BY_COST_CENTER,
    GET_USER_COST_CENTERS,
    SET_USER_COST_CENTERS,
    GET_USER_COST_CENTERS_MODULES_LIST,
    SET_USER_COST_CENTERS_MODULES_LIST,
    GET_SAVE_USER_COST_CENTERS_MODULES,
    SET_SAVE_USER_COST_CENTERS_MODULES
}